import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac88e73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container container--animation" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"title\" data-v-0ac88e73> Главная страница </h1><p class=\"text\" data-v-0ac88e73> Что было реализовано в приложении </p><ul class=\"list\" data-v-0ac88e73><li class=\"list__element\" data-v-0ac88e73> Регистрация пользователей. Незарегистрированным пользователям доступна только главная страница и страницы регистрации/входа. Формы регистрации и входа формируются динамически, согласно переданной в props схеме. </li><li class=\"list__element\" data-v-0ac88e73> Создание, редактирование и удаление задачи, задачи доступны только самому пользователю. Есть также групповые задачи, доступные всем пользователям, но удалять/менять/завершать эти задачи может только автор. Просроченные задачи подсвечиваются красным и помещаются вверх списка. </li><li class=\"list__element\" data-v-0ac88e73> При создании задачи необходимо указать время, описание и важность, валидация предусмотрена. </li><li class=\"list__element\" data-v-0ac88e73> Возможность фильтрации по названию и сортировки по дате, названию, важности. </li><li class=\"list__element\" data-v-0ac88e73> Динамическая страница редактирования задачи, с динамическим значением полей формы. </li><li class=\"list__element\" data-v-0ac88e73> Встроенная анимация vue </li><li class=\"list__element\" data-v-0ac88e73> Динамические роуты и обработка несуществующих роутов, routeguard. </li><li class=\"list__element\" data-v-0ac88e73> Состояние приложения сохраняется при перезагрузке, используется Firebase </li></ul><p class=\"text\" data-v-0ac88e73> Проект подготовлен по материалам youtube(<a href=\"https://www.youtube.com/@UlbiTV\" data-v-0ac88e73>UlbiTV</a>, <a href=\"https://www.youtube.com/@NetNinja\" data-v-0ac88e73>NetNinja</a> и другие), stackoverflow, <a href=\"https://medium.com\" data-v-0ac88e73>https://medium.com</a>, <a href=\"https://www.vuemastery.com\" data-v-0ac88e73>vueMastery</a>, документации и пр. </p><p class=\"text\" data-v-0ac88e73> Какие технологии и плагины использовались </p><ul class=\"list\" data-v-0ac88e73><li class=\"list__element\" data-v-0ac88e73> Vue3 </li><li class=\"list__element\" data-v-0ac88e73> Vue CLI </li><li class=\"list__element\" data-v-0ac88e73> Vue router </li><li class=\"list__element\" data-v-0ac88e73> Vuex </li><li class=\"list__element\" data-v-0ac88e73> Firebase </li><li class=\"list__element\" data-v-0ac88e73><s data-v-0ac88e73>Axios</s> так как используется firebase, то axios не применяется </li><li class=\"list__element\" data-v-0ac88e73> Seeders </li><li class=\"list__element\" data-v-0ac88e73> Options API, с последующим рефактором в пользу Composition API и script setup </li><li class=\"list__element\" data-v-0ac88e73> Typescript </li><li class=\"list__element\" data-v-0ac88e73> SCSS </li><li class=\"list__element\" data-v-0ac88e73> @vueform/multiselect для селекта </li><li class=\"list__element\" data-v-0ac88e73> @vuepic/vue-datepicker для выбора даты </li><li class=\"list__element\" data-v-0ac88e73> vee-validate+yup для валидации форм </li></ul><p class=\"text\" data-v-0ac88e73> Ветки и их особенности </p>", 7)
const _hoisted_9 = { class: "list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list__element" }, " main - основная ветка, в ней лежит последняя версия. ", -1))
const _hoisted_11 = { class: "list__element" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list__element" }, " improvement(WIP) - различные улучшения, оптимизации, редизайн. ", -1))

import BasicSvgIcon from '@/components/UI/BasicSvgIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("span", null, [
          _createTextVNode("options-api "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode(" → composition-api "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode(" → typescript "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode(" → firebase "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode(" → forms "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode("  →script setup "),
          _createVNode(BasicSvgIcon, {
            name: "check-icon",
            width: "16",
            height: "16"
          }),
          _createTextVNode(" названия говорят сами за себя")
        ])
      ]),
      _hoisted_12
    ])
  ]))
}
}

})